"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseApi = exports.API_PATHS = void 0;
const store_1 = require("../store");
const frontend_utils_1 = require("frontend-utils");
const constants_1 = require("../constants");
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../utils");
const appSlice_1 = require("../store/appSlice");
const HTTP_METHODS_MAP = {
    POST: "POST",
    GET: "GET",
};
exports.API_PATHS = {
    GET_CONSENT_DATA: "/v2/getConsentTokenData?consentToken=",
    GRANT_CONSENT: "/v2/grantConsent",
    SIGN_MESSAGE: "/v2/app/sign/message",
    SIGN_TRANSACTION: "/v2/app/sign/transaction",
    SIGN_TRANSACTION_MULTIPLE: "/v2/app/sign/transaction/multiple",
    SIGN_TYPED_DATA: "/v2/app/sign/typedData",
    GET_WALLET: "/v3/getWallet",
    GET_APP_DETAILS: "/v2/getPublicAppData",
    DECRYPT: "/v2/app/data/decrypt",
};
const API_CONFIG = {
    [exports.API_PATHS.GET_CONSENT_DATA]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.GET_CONSENT_DATA,
        authRequired: false,
        appIdRequired: false,
        apiSignatureRequired: false,
        requesterOriginRequired: true,
        baseUrl: constants_1.API_URL,
    },
    [exports.API_PATHS.GRANT_CONSENT]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.GRANT_CONSENT,
        authRequired: true,
        appIdRequired: false,
        apiSignatureRequired: true,
        requesterOriginRequired: true,
        baseUrl: constants_1.API_URL,
        isProcessingLoaderEnabled: true,
    },
    [exports.API_PATHS.SIGN_MESSAGE]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.SIGN_MESSAGE,
        authRequired: true,
        appIdRequired: false,
        apiSignatureRequired: true,
        requesterOriginRequired: true,
        baseUrl: constants_1.API_URL,
    },
    [exports.API_PATHS.SIGN_TRANSACTION]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.SIGN_TRANSACTION,
        authRequired: true,
        appIdRequired: false,
        apiSignatureRequired: true,
        requesterOriginRequired: true,
        baseUrl: constants_1.API_URL,
    },
    [exports.API_PATHS.SIGN_TRANSACTION_MULTIPLE]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.SIGN_TRANSACTION_MULTIPLE,
        authRequired: true,
        appIdRequired: false,
        apiSignatureRequired: true,
        requesterOriginRequired: true,
        baseUrl: constants_1.API_URL,
    },
    [exports.API_PATHS.SIGN_TYPED_DATA]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.SIGN_TYPED_DATA,
        authRequired: true,
        appIdRequired: false,
        apiSignatureRequired: true,
        requesterOriginRequired: true,
        baseUrl: constants_1.API_URL,
    },
    [exports.API_PATHS.GET_WALLET]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.GET_WALLET,
        authRequired: false,
        appIdRequired: true,
        apiSignatureRequired: false,
        requesterOriginRequired: true,
        baseUrl: constants_1.API_URL,
    },
    [exports.API_PATHS.GET_APP_DETAILS]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.GET_APP_DETAILS,
        authRequired: false,
        appIdRequired: false,
        apiSignatureRequired: false,
        requesterOriginRequired: true,
        baseUrl: constants_1.API_URL,
    },
    [exports.API_PATHS.DECRYPT]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.DECRYPT,
        authRequired: true,
        appIdRequired: false,
        apiSignatureRequired: true,
        requesterOriginRequired: true,
        baseUrl: constants_1.API_URL,
    },
};
const getApiHost = (baseUrl) => baseUrl.replace(/^https:\/\//, "");
const addApiSignature = async (apiConfig, existingHeaders, requestBody) => {
    var _a, _b, _c;
    const timeStamp = Date.now().toString();
    const currentParsedUser = store_1.useStore.getState().user;
    const requestBodyString = requestBody ? JSON.stringify(requestBody) : "";
    const timestampHeader = `${constants_1.X_TIMESTAMP_HEADER}:${timeStamp}`;
    let signedRequest = "";
    const sessionId = (_b = (_a = (await frontend_utils_1.MetakeepAuth.currentSession())) === null || _a === void 0 ? void 0 : _a.getIdToken()) === null || _b === void 0 ? void 0 : _b.payload.origin_jti;
    const fetchKeysParams = {
        keyPrefix: constants_1.METAKEEP_IDENTITY_PROVIDER_PREFIX,
        parsedUser: currentParsedUser,
        sessionId: sessionId,
    };
    const webauthnKey = (await frontend_utils_1.SessionKeysUtils.fetchKeysFromDb(Object.assign(Object.assign({}, fetchKeysParams), { keyType: frontend_utils_1.SessionKeysUtils.SESSION_KEY_TYPES.WEBAUTHN })));
    const cryptoKey = await frontend_utils_1.SessionKeysUtils.fetchKeysFromDb(Object.assign(Object.assign({}, fetchKeysParams), { keyType: frontend_utils_1.SessionKeysUtils.SESSION_KEY_TYPES.CRYPTO }));
    if (webauthnKey) {
        try {
            // We don't set loading for Passkey sign request so that users can see
            // the operation that is being performed in the background.
            signedRequest = await frontend_utils_1.PasskeyUtils.signRequest({
                credentialId: webauthnKey.credentialId,
                hostname: getApiHost(apiConfig.baseUrl),
                method: apiConfig.method,
                path: apiConfig.path,
                timestampHeader,
                requestData: requestBodyString,
            });
        }
        catch (_d) {
            // We should ideally allow users to retry in this case.
            // The caller should decide how to handle this error.
            throw new Error(constants_1.PASSKEY_SIGN_FAILED);
        }
    }
    else {
        signedRequest =
            (_c = (await frontend_utils_1.CryptoUtils.signRequest(requestBodyString, cryptoKey, timestampHeader, apiConfig.method, apiConfig.path, getApiHost(apiConfig.baseUrl)))) !== null && _c !== void 0 ? _c : "";
    }
    existingHeaders.append(constants_1.X_TIMESTAMP_HEADER, timeStamp);
    signedRequest &&
        existingHeaders.append(constants_1.X_API_SIGNATURE_HEADER, signedRequest);
};
const addAuthorizationHeader = async (existingHeaders, apiConfig) => {
    var _a;
    const idToken = (_a = (await frontend_utils_1.MetakeepAuth.currentSession())) === null || _a === void 0 ? void 0 : _a.getIdToken();
    const payload = idToken === null || idToken === void 0 ? void 0 : idToken.payload;
    if (apiConfig.checkForSessionKeyInToken && !(payload === null || payload === void 0 ? void 0 : payload.sessionKey))
        throw new Error("Session key not found in token");
    const jwtToken = idToken === null || idToken === void 0 ? void 0 : idToken.getJwtToken();
    existingHeaders.append("Authorization", `Bearer ${jwtToken}`);
};
const addRequesterOriginHeader = (existingHeaders) => {
    const requesterDomain = store_1.useStore.getState().requesterDomain;
    const hasDomain = requesterDomain !== utils_1.MISSING_REQUESTER_DOMAIN;
    if (hasDomain)
        existingHeaders.append(constants_1.X_ORIGIN_HEADER, requesterDomain || "");
};
const addAppIdHeader = (existingHeaders) => {
    const appId = store_1.useStore.getState().appId;
    existingHeaders.append(constants_1.X_APP_ID_HEADER, appId || "");
};
const baseApi = async ({ apiPath, requestBody = null, queryParams = null, }) => {
    var _a;
    // The API sends request in 3 steps:
    // 1. Sign the request using Passkey or Crypto-KeyPair
    // 2. Show a processing snackbar for 4s to allow users to cancel the operation
    // 3. Submit the request after 4s.
    const setSnackbarState = store_1.useStore.getState().setSnackbarState;
    const setLoading = store_1.useStore.getState().setLoading;
    const apiConfig = API_CONFIG[apiPath];
    const showProcessingLoader = ((_a = store_1.useStore.getState().userWallet) === null || _a === void 0 ? void 0 : _a.processingLoader) ===
        appSlice_1.PROCESSING_LOADER_STATE.ENABLED && apiConfig.isProcessingLoaderEnabled;
    if (!apiConfig)
        throw new Error(`Invalid api path: ${apiPath}`);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    requestBody = requestBody || {};
    // Add api signature header if api requires it
    if (apiConfig.apiSignatureRequired)
        await addApiSignature(apiConfig, headers, requestBody);
    // Add authorization header if api is authenticated
    // If this API requires authentication, we also show a 4s loader to allow users to cancel the operation.
    if (apiConfig.authRequired) {
        if (showProcessingLoader) {
            const snackbarPromise = new Promise((resolve) => {
                setLoading(false);
                setSnackbarState({
                    message: "Processing",
                    open: true,
                    onCompleteCb: async () => {
                        await addAuthorizationHeader(headers, apiConfig);
                        setLoading(true);
                        // Resolve the promise once onCompleteCb is executed
                        resolve();
                    },
                });
            });
            await snackbarPromise;
        }
        else {
            await addAuthorizationHeader(headers, apiConfig);
            setLoading(true);
        }
    }
    // Add requester origin header
    if (apiConfig.requesterOriginRequired)
        addRequesterOriginHeader(headers);
    // Add app id header
    if (apiConfig.appIdRequired)
        addAppIdHeader(headers);
    const headersObj = {};
    for (const headerPair of headers.entries()) {
        headersObj[headerPair[0]] = headerPair[1];
    }
    let apiUrl = apiConfig.baseUrl + apiConfig.path;
    if (queryParams)
        apiUrl = apiUrl + queryParams;
    const apiCallConfig = {
        method: apiConfig.method,
        url: apiUrl,
        headers: headersObj,
        data: undefined, // Add the 'data' property with type 'any'
    };
    if (requestBody)
        apiCallConfig.data = JSON.stringify(requestBody);
    return (await (0, axios_1.default)(apiCallConfig)).data;
};
exports.baseApi = baseApi;
